import React from 'react';
import HoverIcon from 'components/HoverIcon';
import { A } from 'components/Typography';
import Feather from 'assets/img/logos/feather-white.png';
import Facebook from 'assets/img/icons/some/facebook.svg';
import FacebookWhite from 'assets/img/icons/some/facebook-white.svg';
import Twitter from 'assets/img/icons/some/twitter.svg';
import TwitterWhite from 'assets/img/icons/some/twitter-white.svg';
import Instagram from 'assets/img/icons/some/instagram.svg';
import InstagramWhite from 'assets/img/icons/some/instagram-white.svg';
import LinkedIn from 'assets/img/icons/some/linkedin.svg';
import LinkedInWhite from 'assets/img/icons/some/linkedin-white.svg';
import YouTube from 'assets/img/icons/some/youtube.svg';
import YouTubeWhite from 'assets/img/icons/some/youtube-white.svg';
import {
  FooterContainer,
  FeatherLogo,
  LocationsContainer,
  Locations,
  Heading,
  FooterLink,
  CopyrightText,
  InternalLinks,
  SocialIcons,
  Icons
} from './styled';

const Footer = () => {
  return (
    <FooterContainer>
      <LocationsContainer>
        <FeatherLogo src={Feather} alt="feather logo" />
        <Locations>
          <p>San Francisco, USA</p>
          <p>Oslo, Norway</p>
        </Locations>
      </LocationsContainer>
      <InternalLinks>
        <div>
          <Heading>About us</Heading>
          <FooterLink to="/team">Team</FooterLink>
          <FooterLink to="/ambassador">Partners</FooterLink>
          <FooterLink to="/contact">Contact us</FooterLink>
          <FooterLink to="/ambassador">Become an Ambassador</FooterLink>
          <FooterLink to="/join-us">Join us</FooterLink>
        </div>
        <div>
          <Heading>Products</Heading>
          <FooterLink to="/nomad-insurance" variant="darkBgLink">
            Nomad Insurance
          </FooterLink>
          <FooterLink to="/remote-health" variant="darkBgLink">
            Remote Health
          </FooterLink>
        </div>
        <div>
          <Heading>Legal</Heading>
          <FooterLink to="/terms-and-conditions" variant="darkBgLink">
            Terms and conditions
          </FooterLink>
          <FooterLink to="/privacy-policy" variant="darkBgLink">
            Privacy policy
          </FooterLink>
        </div>
      </InternalLinks>
      <SocialIcons>
        <div>
          <Heading>Social</Heading>
          <Icons>
            <A href="https://www.facebook.com/safetywing/">
              <HoverIcon src={Facebook} hoverSrc={FacebookWhite} hover alt="facebook" />
            </A>
            <A href="https://twitter.com/safetywing">
              <HoverIcon src={Twitter} hoverSrc={TwitterWhite} alt="twitter" />
            </A>
            <A href="https://www.instagram.com/safetywing">
              <HoverIcon src={Instagram} hoverSrc={InstagramWhite} alt="instagram" />
            </A>
            <A href="https://www.youtube.com/channel/UCotagRRzqxRZ4nAECs6vASQ/">
              <HoverIcon src={YouTube} hoverSrc={YouTubeWhite} alt="youtube" />
            </A>
            <A href="https://www.linkedin.com/company/safetywing/">
              <HoverIcon src={LinkedIn} hoverSrc={LinkedInWhite} alt="medium" />
            </A>
          </Icons>
          <CopyrightText>{`©${new Date().getFullYear()}, Safety Nest, Inc. All rights reserved.`}</CopyrightText>
        </div>
      </SocialIcons>
    </FooterContainer>
  );
};

export default Footer;
